<template>
  <v-container>
    <v-row v-if="classData">
      <div class="display-1">{{ classData.name }}</div>
    </v-row>

    <v-row v-if="classData">
      <v-col cols="3">
        <v-card tile class="mr-1 ml-n2">
          <v-list>
            <v-subheader class="headline">Værktøjer</v-subheader>
            <v-list-item-group>
              <v-list-item :to="`/hold/${classData.slug}`">
                <v-list-item-icon>
                  <v-icon>mdi-view-dashboard-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Overblik</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item :to="`/hold/${classData.slug}/sms`">
                <v-list-item-icon>
                  <v-icon>mdi-email-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SMS</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item-group v-if="`$route.path !=='/hold/${classData.slug}/sms'`">
                <v-divider></v-divider>
                <v-list-item dense :to="`/hold/${classData.slug}/sms/planlagte`">
                  <v-list-item-icon class="ml-3">
                    <v-icon>mdi-clock-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Planlagte</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-show="false" dense :to="`/hold/${classData.slug}/sms/sendte`">
                  <v-list-item-icon class="ml-3">
                    <v-icon>mdi-email-check-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Sendte</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </v-list-item-group>

              <v-list-item :to="`/hold/${classData.slug}/fremmoede`">
                <v-list-item-icon>
                  <v-icon>mdi-format-list-checks</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Fremmøde</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :to="`/hold/${classData.slug}/inaktive`">
                <v-list-item-icon>
                  <v-icon>mdi-account-off-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Tidligere elever</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>

      <v-col cols="9">
        <router-view :classData="classData" :persons="persons">></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue2Filters from "vue2-filters";
export default {
  mixins: [Vue2Filters.mixin],
  methods: {
    initials(userData) {
      if (userData.firstName && userData.lastName) {
        return userData.firstName.charAt(0) + userData.lastName.charAt(0);
      }
    }
  },
  created() {
    this.$store.dispatch("GET_CLASSES");
    this.$store.dispatch("activePersons");
  },
  data() {
    return {
      test: "test"
    };
  },
  computed: {
    classes() {
      return this.$store.state.classes;
    },
    persons() {
      let result = [];
      if (this.classData) {
        result = this.filterBy(
          this.$store.getters.getList,
          this.classData.id,
          "class"
        );
      }

      if (result.length == 0) {
        result = null;
      }
      return result;
    },
    /* persons() {
      return this.$store.getters.getList;
    }, */
    classData() {
      if (this.classes) {
        let hold = this.classes.find(obj => {
          return obj.slug === this.$route.params.id;
        });
        return hold;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
